import React, { SVGProps } from 'react';

const PrivacyPolicyIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 14 17"
			fill="none"
			{...props}
		>
			<path
				d="M13.7294 6.99859C13.6853 4.70172 13.3653 3.00766 13.3697 3.00609C13.2366 2.74641 13.0032 2.52922 12.7175 2.41828C10.8425 1.69109 8.99878 0.997031 7.20128 0.404844C7.01753 0.344219 6.82378 0.344219 6.64034 0.404844C4.84316 0.995469 2.99972 1.68828 1.12503 2.41453C0.872844 2.51234 0.661281 2.69328 0.523469 2.91328C0.534094 2.91453 0.138156 4.15047 0.0706563 6.88016C0.0306563 9.61016 0.370656 10.428 0.359406 10.4289C0.543469 11.0289 0.887844 11.6392 1.38128 12.2598C1.93284 12.953 2.67816 13.6689 3.57847 14.3727C5.06878 15.5423 6.46347 16.2414 6.52191 16.2661C6.64847 16.328 6.78253 16.3595 6.92066 16.3592C7.05909 16.3592 7.19316 16.3277 7.31941 16.2655C7.37816 16.2408 8.77441 15.5395 10.2641 14.3702C11.1647 13.6658 11.91 12.9498 12.4619 12.257C12.9907 11.5923 13.3482 10.9402 13.521 10.2995C13.5141 10.2986 13.7641 9.29609 13.7294 6.99891V6.99859ZM7.66253 8.79016V10.2455C7.66253 10.6555 7.33034 10.9877 6.92034 10.988C6.51034 10.988 6.17784 10.6558 6.17784 10.2458V8.81078C5.64284 8.54484 5.27472 7.99297 5.27472 7.35516C5.27472 6.45766 6.00222 5.72984 6.89972 5.72984C7.79722 5.72984 8.52472 6.45734 8.52503 7.35484C8.52503 7.97672 8.17566 8.51703 7.66253 8.79016Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default PrivacyPolicyIcon;
